import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface ReportInformationCardProps {
  date: string;
  ordering: string;
  performing: string;
  title: string;
}

const ReportInformationCard = ({ date, ordering, performing, title }: ReportInformationCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex flex-col bg-white p-4">
      <Text className="gbmask mb-4 text-lg font-bold text-secondary-green">{title}</Text>
      {!!date && (
        <>
          <Text className="text-sm text-gray-500">{t('labTestResults.summaryCard.dateTime')}</Text>
          <Text className="text-sm gbmask mb-2 font-bold">{date}</Text>
        </>
      )}
      {!!ordering && (
        <>
          <Text className="text-sm text-gray-500">{t('labTestResults.summaryCard.orderingFacility')}</Text>
          <Text className="text-sm gbmask mb-2 font-bold">{ordering}</Text>
        </>
      )}
      {!!performing && (
        <>
          <Text className="text-sm text-gray-500">{t('labTestResults.summaryCard.performingFacility')}</Text>
          <Text className="text-sm gbmask mb-2 font-bold">{performing}</Text>
        </>
      )}
    </div>
  );
};

export default ReportInformationCard;
